import { render, staticRenderFns } from "./library-roles-editor.vue?vue&type=template&id=278aeccc&scoped=true&"
import script from "./library-roles-editor.vue?vue&type=script&lang=js&"
export * from "./library-roles-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278aeccc",
  null
  
)

export default component.exports